export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10652.596a98cb.jpg";